/**
 * Download file from service URL.
 * @param {*} data
 * @param {string} fileName
 * @param {string} extension
 */
export const downloadFile = (data, fileName = 'sampleFile', extension = 'pdf') => {
  if (data) {
    const url = window.URL.createObjectURL(new Blob([data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `${fileName}.${extension}`);
    document.body.appendChild(link);
    link.click();
    link.remove();
  }
};

export default {
  downloadFile
}